import { render, staticRenderFns } from "./constractorstEndorsement.vue?vue&type=template&id=241d5808&scoped=true&"
import script from "./constractorstEndorsement.vue?vue&type=script&lang=js&"
export * from "./constractorstEndorsement.vue?vue&type=script&lang=js&"
import style0 from "./constractorstEndorsement.vue?vue&type=style&index=0&id=241d5808&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "241d5808",
  null
  
)

export default component.exports